import { render, staticRenderFns } from "./ModalDuplicationCommande.vue?vue&type=template&id=6fa7a5c1&"
import script from "./ModalDuplicationCommande.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicationCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa7a5c1')) {
      api.createRecord('6fa7a5c1', component.options)
    } else {
      api.reload('6fa7a5c1', component.options)
    }
    module.hot.accept("./ModalDuplicationCommande.vue?vue&type=template&id=6fa7a5c1&", function () {
      api.rerender('6fa7a5c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commandes/ModalDuplicationCommande.vue"
export default component.exports